<div class="content-box">
  <app-breadcrumb pagina="Responsável LGPD"></app-breadcrumb>

  <section class="lgpd" aria-labelledby="lgpd-titulo">
    <h1 class="lgpd-titulo" id="lgpd-titulo">
      Responsável LGPD
      <span class="lgpd-enfeites" aria-hidden="true">
        <span class="lgpd-enfeite-traco"></span>
        <span class="lgpd-enfeite-ponto"></span>
        <span class="lgpd-enfeite-ponto"></span>
      </span>
    </h1>

    <article class="lgpd-encarregado">
      <span class="lgpd-encarregado-selo" aria-hidden="true">
        <i-lucide name="shield-alert" size="24"></i-lucide>
      </span>

      <div class="lgpd-encarregado-topo">
        <span class="lgpd-encarregado-avatar" aria-hidden="true">
          <i-lucide name="user" size="32"></i-lucide>
        </span>

        <div>
          <p class="lgpd-encarregado-papel">{{ encarregado.papel }}</p>
          <h2 class="lgpd-encarregado-nome">{{ encarregado.nome }}</h2>

          <p class="lgpd-encarregado-contatos">
            <a class="lgpd-encarregado-contato" [href]="telefoneHref()">
              <i-lucide name="phone" size="16" aria-hidden="true"></i-lucide>
              {{ encarregado.telefone }}
            </a>

            <a class="lgpd-encarregado-contato" [href]="emailHref()">
              <i-lucide name="mail" size="16" aria-hidden="true"></i-lucide>
              {{ encarregado.email }}
            </a>
          </p>
        </div>
      </div>

      <dl class="lgpd-encarregado-dados">
        <div class="lgpd-encarregado-dado">
          <dt>Cargo / Função</dt>
          <dd>{{ encarregado.cargo }}</dd>
        </div>

        <div class="lgpd-encarregado-dado">
          <dt>Órgão</dt>
          <dd>{{ encarregado.orgao }}</dd>
        </div>

        <div class="lgpd-encarregado-dado">
          <dt>Horário de atendimento</dt>
          <dd>{{ encarregado.horario }}</dd>
        </div>

        <div class="lgpd-encarregado-dado">
          <dt>Endereço</dt>
          <dd>{{ encarregado.endereco }}</dd>
        </div>
      </dl>
    </article>

    <br>

    <div class="lgpd-destaques">
      @for (destaque of destaques; track destaque.id) {
      <article class="lgpd-destaque" [attr.data-cor]="destaque.cor">
        <span class="lgpd-destaque-icone" aria-hidden="true">
          <i-lucide [name]="destaque.icone" size="18"></i-lucide>
        </span>

        <div>
          <h2 class="lgpd-destaque-titulo">{{ destaque.titulo }}</h2>
          <p class="lgpd-destaque-texto">{{ destaque.texto }}</p>
        </div>
      </article>
      }
    </div>

    <br>

    <div class="lgpd-colunas">
      <section class="lgpd-bloco" aria-labelledby="lgpd-documentos-titulo">
        <h2 class="lgpd-bloco-titulo" id="lgpd-documentos-titulo">
          <i-lucide name="paperclip" size="20" aria-hidden="true"></i-lucide>
          Documentos e Regulamentos
        </h2>

        <ul class="lgpd-documentos">
          @for (documento of documentosResumo(); track documento.id) {
          <li class="lgpd-documento">
            <span class="lgpd-documento-icone" aria-hidden="true">
              <i-lucide name="file-down" size="22"></i-lucide>
            </span>

            <div class="lgpd-documento-corpo">
              <p class="lgpd-documento-categoria">{{ documento.categoria }}</p>
              <p class="lgpd-documento-arquivo">{{ documento.arquivo }}</p>
              <p class="lgpd-documento-meta">
                {{ documento.formato }} · {{ documento.tamanho }} · {{ documento.data }}
              </p>
            </div>

            <button type="button" class="btn btn-visualizar" (click)="visualizarDocumento(documento)">
              <i-lucide name="eye" size="16" aria-hidden="true"></i-lucide>
              Visualizar
            </button>
          </li>
          }
        </ul>

        @if (temMaisDocumentos()) {
        <button type="button" class="lgpd-link lgpd-link-botao" (click)="abrirTodosDocumentos()">
          Ver todos os documentos →
        </button>
        }
      </section>

      <section class="lgpd-bloco" aria-labelledby="lgpd-perguntas-titulo">
        <h2 class="lgpd-bloco-titulo" id="lgpd-perguntas-titulo">
          <i-lucide name="circle-question-mark" size="20" aria-hidden="true"></i-lucide>
          Perguntas frequentes
        </h2>

        <ul class="lgpd-perguntas">
          @for (item of perguntas; track item.id) {
          <li class="lgpd-pergunta">
            <h3 class="lgpd-pergunta-cabecalho">
              <button type="button" class="lgpd-pergunta-botao" [attr.aria-expanded]="perguntaAberta() === item.id"
                [attr.aria-controls]="'lgpd-resposta-' + item.id" (click)="alternarPergunta(item.id)">
                {{ item.pergunta }}

                <i-lucide class="lgpd-pergunta-seta"
                  [name]="perguntaAberta() === item.id ? 'chevron-up' : 'chevron-down'" size="18"
                  aria-hidden="true"></i-lucide>
              </button>
            </h3>

            @if (perguntaAberta() === item.id) {
            <p class="lgpd-pergunta-resposta" [id]="'lgpd-resposta-' + item.id">{{ item.resposta }}</p>
            }
          </li>
          }
        </ul>

        <a class="lgpd-link" routerLink="/perguntas-frequentes">Ver todas as perguntas →</a>
      </section>
    </div>

    <div class="lgpd-rodape">
      <section class="lgpd-rodape-item" aria-labelledby="lgpd-importante-titulo">
        <h2 class="lgpd-rodape-titulo" id="lgpd-importante-titulo">
          <i-lucide name="info" size="16" aria-hidden="true"></i-lucide>
          Importante
        </h2>

        <p class="lgpd-rodape-texto">
          Caso tenha dúvidas sobre o uso dos seus dados pessoais ou queira exercer seus direitos previstos na
          LGPD, entre em contato com o Encarregado de Dados pelos canais acima.
        </p>
      </section>

      <section class="lgpd-rodape-item" aria-labelledby="lgpd-base-titulo">
        <h2 class="lgpd-rodape-titulo" id="lgpd-base-titulo">Base legal</h2>

        <ul class="lgpd-rodape-lista">
          @for (base of baseLegal; track base) {
          <li>{{ base }}</li>
          }
        </ul>
      </section>
    </div>

    <br>

    <section class="atendimento-acessos mt-3" aria-labelledby="atendimento-acessos-titulo">
      <h2 class="atendimento-oculto" id="atendimento-acessos-titulo">Acesso rápido</h2>

      <ul class="atendimento-acessos-grade">
        <li>
          <a class="atendimento-acesso" data-cor="azul" routerLink="/perguntas-frequentes">
            <span class="atendimento-acesso-circulo" aria-hidden="true">
              <i-lucide name="circle-question-mark" size="24"></i-lucide>
            </span>

            <span class="atendimento-acesso-titulo">Perguntas frequentes</span>
          </a>
        </li>

        <li>
          <a class="atendimento-acesso" data-cor="roxo" routerLink="/outros-canais-atendimento">
            <span class="atendimento-acesso-circulo" aria-hidden="true">
              <i-lucide name="headphones" size="24"></i-lucide>
            </span>

            <span class="atendimento-acesso-titulo">Outros canais de atendimento ao cidadão</span>
          </a>
        </li>

        <li>
          <a class="atendimento-acesso" data-cor="amarelo" routerLink="/politica-atendimento">
            <span class="atendimento-acesso-circulo" aria-hidden="true">
              <i-lucide name="file-text" size="24"></i-lucide>
            </span>

            <span class="atendimento-acesso-titulo">Política de atendimento ao cidadão</span>
          </a>
        </li>

        <li>
          <a class="atendimento-acesso" data-cor="verde" routerLink="/ouvidoria">
            <span class="atendimento-acesso-circulo" aria-hidden="true">
              <i-lucide name="megaphone" size="24"></i-lucide>
            </span>

            <span class="atendimento-acesso-titulo">Ouvidoria geral do município</span>
          </a>
        </li>
      </ul>
    </section>
  </section>

  <dialog #modalPdf class="lgpd-pdf-modal" aria-labelledby="lgpd-pdf-modal-titulo">
    @if (documentoPdf(); as documento) {
    <div class="lgpd-pdf-modal-conteudo">
      <div class="lgpd-pdf-modal-topo">
        <div>
          <h2 class="lgpd-pdf-modal-titulo" id="lgpd-pdf-modal-titulo">{{ documento.arquivo }}</h2>
          <p class="lgpd-pdf-modal-categoria">{{ documento.categoria }}</p>
        </div>

        <button type="button" class="lgpd-pdf-modal-fechar" (click)="fecharPdf()" aria-label="Fechar">
          <i-lucide name="x" size="20" aria-hidden="true"></i-lucide>
        </button>
      </div>

      <div class="lgpd-pdf-modal-corpo">
        <ngx-extended-pdf-viewer [src]="documento.url" [height]="'75vh'" [textLayer]="true" [showHandToolButton]="true"
          [filenameForDownload]="documento.arquivo"></ngx-extended-pdf-viewer>
      </div>
    </div>
    }
  </dialog>

  <dialog #modalDocumentos class="lgpd-documentos-modal" aria-labelledby="lgpd-documentos-modal-titulo">
    <div class="lgpd-documentos-modal-conteudo">
      <div class="lgpd-documentos-modal-topo">
        <h2 class="lgpd-documentos-modal-titulo" id="lgpd-documentos-modal-titulo">
          Documentos e Regulamentos
        </h2>

        <button type="button" class="lgpd-documentos-modal-fechar" (click)="fecharTodosDocumentos()"
          aria-label="Fechar">
          <i-lucide name="x" size="20" aria-hidden="true"></i-lucide>
        </button>
      </div>

      <ul class="lgpd-documentos lgpd-documentos-modal-lista">
        @for (documento of documentos; track documento.id) {
        <li class="lgpd-documento">
          <span class="lgpd-documento-icone" aria-hidden="true">
            <i-lucide name="file-down" size="22"></i-lucide>
          </span>

          <div class="lgpd-documento-corpo">
            <p class="lgpd-documento-categoria">{{ documento.categoria }}</p>
            <p class="lgpd-documento-arquivo">{{ documento.arquivo }}</p>
            <p class="lgpd-documento-meta">
              {{ documento.formato }} · {{ documento.tamanho }} · {{ documento.data }}
            </p>
          </div>

          <button type="button" class="btn btn-visualizar" (click)="visualizarDocumento(documento)">
            <i-lucide name="eye" size="16" aria-hidden="true"></i-lucide>
            Visualizar
          </button>
        </li>
        }
      </ul>
    </div>
  </dialog>
</div>